export const tableNameMap: Record<string, string> = {
  articles: 'Статьи',
  products: 'Товары',
  roles: 'Роли',
  users: 'Пользователи',
  plan_records: 'Плановые записи',
  fact_records: 'Фактические записи',
  finance_operations: 'Финансовые операции',
  mappings: 'Сопоставление',
  queries: 'Поисковые запросы',
  app_settings: 'Настройки приложения',
  deliveries: 'Поставки',
  delivery_details: 'Детали поставок',
  draft_orders: 'Черновые заказы',
  migrations: 'Миграции',
  tenant_schema_migrations: 'Миграции схемы арендатора',
  tenant_schema_migration: 'Миграции схемы арендатора',
  delivery_sync_state: 'Состояние синхронизации доставок',
  product_groups: 'Группы товаров',
  articles_closure: 'Иерархия статей',
  promo_by_orders: 'Промо по заказам',
  promo_task: 'Промо задачи',
  queries_harvest_requests: 'Запросы на сбор запросов',
  warehouse_types: 'Типы складов',
  warehouses: 'Склады',
};

export const columnNameMap: Record<string, Record<string, string>> = {
  articles: {
    id: 'ID',
    name: 'Название',
    code: 'Код',
    isIncome: 'Приход',
    is_income: 'Приход',
    number: 'Номер',
    groupNumber: 'Группа',
    group_number: 'Группа',
    parentId: 'Родитель',
    parent_id: 'Родитель',
    aliases: 'Алиасы',
    exclude_from_common_expenses: 'Исключить из общих расходов',
  },
  products: {
    id: 'ID',
    name: 'Название',
    alias: 'Алиас',
    sku: 'Артикул товара',
  },
  roles: {
    id: 'ID',
    name: 'Название',
    level: 'Уровень',
  },
  users: {
    id: 'ID',
    name: 'Имя',
    email: 'Email',
    phone: 'Телефон',
    passwordHash: 'Пароль',
    password_hash: 'Пароль',
    roleId: 'Роль',
    role_id: 'Роль',
  },
  plan_records: {
    id: 'ID',
    dateMonthEnd: 'Дата',
    date_month_end: 'Дата',
    articleId: 'Статья',
    article_id: 'Статья',
    productId: 'Товар',
    product_id: 'Товар',
    amount: 'Сумма',
    quantity: 'Количество',
    comment: 'Комментарий',
    ownerId: 'Ответственный',
    owner_id: 'Ответственный',
    createdAt: 'Создано',
    created_at: 'Создано',
  },
  fact_records: {
    id: 'ID',
    date: 'Дата',
    articleId: 'Статья',
    article_id: 'Статья',
    externalId: 'Внешний код',
    external_id: 'Внешний код',
    processedAt: 'Обработан',
    processed_at: 'Обработан',
    warehouse: 'Склад',
    productId: 'Товар',
    product_id: 'Товар',
    quantity: 'Количество',
    price: 'Цена',
    commissionRate: 'Комиссия,%',
    commission_rate: 'Комиссия,%',
    commission: 'Комиссия',
    assembly: 'Сборка',
    dispatch: 'Отправка',
    trunk: 'Магистраль',
    lastMile: 'П.Миля',
    last_mile: 'П.Миля',
    returnTrunk: 'Возврат',
    return_trunk: 'Возврат',
    returnProcessing: 'Возврат обр.',
    return_processing: 'Возврат обр.',
    cancelProcessing: 'Отмена обр.',
    cancel_processing: 'Отмена обр.',
    noBuyProcessing: 'Не выкуп обр.',
    no_buy_processing: 'Не выкуп обр.',
    logistics: 'Логистика',
    reverseLogistics: 'Обратная логистика',
    reverse_logistics: 'Обратная логистика',
    totalCost: 'Сумма',
    total_cost: 'Сумма',
  },
  finance_operations: {
    id: 'ID',
    date: 'Дата',
    articleId: 'Статья',
    article_id: 'Статья',
    productId: 'Товар',
    product_id: 'Товар',
    income: 'Приход',
    amount: 'Сумма',
    quantity: 'Количество',
    relationId: 'Связь',
    relation_id: 'Связь',
    ownerId: 'Ответственный',
    owner_id: 'Ответственный',
    createdAt: 'Создано',
    created_at: 'Создано',
  },
  mappings: {
    id: 'ID',
    export: 'Выгрузка',
    field: 'Поле',
    articleId: 'Статья',
    article_id: 'Статья',
    sum_field: 'Суммировать',
  },
  queries: {
    id: 'ID',
    sku: 'Артикул товара',
    query: 'Запрос',
    position: 'Позиция',
    order_count: 'Заказы',
    view_conversion: 'Конверсия просмотра',
    unique_search_users: 'Уникальные пользователи поиска',
    unique_view_users: 'Уникальные просмотры',
    date_from: 'Дата начала',
    date_to: 'Дата окончания',
    product_id: 'Товар',
  },
  promo_task: {
    id: 'ID',
    date_time: 'Дата',
    report_type: 'Тип отчета',
    report_id: 'ID отчета',
    report_guid: 'GUID отчета',
    status: 'Статус',
    data: 'Данные',
    update_at: 'Обновлено',
  },
  promo_by_orders: {
    id: 'ID',
    date: 'Дата',
    order_id: 'ID заказа',
    order_number: 'Номер заказа',
    sku: 'Артикул товара',
    sku_promoted: 'Артикул промо',
    article: 'Артикул',
    order_source: 'Источник заказа',
    product_name: 'Товар',
    quantity: 'Количество',
    sale_cost: 'Стоимость продажи',
    cost: 'Стоимость',
    rate_percent: 'Ставка, %',
    rate_amount: 'Сумма ставки',
    expense: 'Расход',
  },
  queries_harvest_requests: {
    id: 'ID',
    start_from: 'Старт с',
    created_at: 'Создано',
    processed_at: 'Обработано',
  },
  deliveries: {
    id: 'ID',
    date: 'Дата',
    boxes: 'Коробки',
    items: 'Штуки',
  },
  delivery_details: {
    id: 'ID',
    date: 'Дата',
    order_id: 'ID заказа',
    boxes: 'Коробки',
    quantity: 'Количество',
    depart_from: 'Откуда',
    depart_to: 'Куда',
  },
  draft_orders: {
    order_id: 'ID заказа',
    has_free_slot: 'Свободный слот',
    checked_at: 'Проверено',
  },
  warehouse_types: {
    id: 'ID',
    name: 'Название',
    is_cluster: 'Кластер',
    is_cross_dock: 'Кросс-док',
  },
  warehouses: {
    id: 'ID',
    name: 'Название',
    type_id: 'Тип склада',
    outer_id: 'Внешний ID',
    cluster_outer_id: 'ID кластера',
  },
};
